module.exports = __webpack_public_path__ + "img/titulo-registrar-banda.8c5d24c0.png";